import { configureStore } from "@reduxjs/toolkit";
import { reguestSlice, reguestGetSlice, reguestPlanSlice, reguestPaymentSlice, reguestNoteSlice, reguestRecipeIdSlice, reguestLibrarySlice, reguestUsersSlice, currentUserSlice } from './reguestSlice'
import IngredientsSlise from './IngredientsSlise'

const store = configureStore({
  reducer: {
    ingredients: reguestSlice.reducer, 
    recipe: reguestRecipeIdSlice.reducer, 
    //addrecipe: reguestPostSlice.reducer,
    recipes: reguestGetSlice.reducer,
    users: reguestUsersSlice.reducer,
    todos: IngredientsSlise,
    lib: reguestLibrarySlice.reducer,
    notes: reguestNoteSlice.reducer,
    plans: reguestPlanSlice.reducer,
    currentUser: currentUserSlice.reducer,
    payment: reguestPaymentSlice.reducer,
  }
  });

export default store;
